import { useMemo } from "react";
import { BookingTabs } from "../../constants";
import { BookingsScreenHeader } from "../../BookingsScreen.styles";
import { isActiveUserAdminAtom } from "../../../../../atoms/user/activeUserAtom";
import { useAtomValue } from "jotai";

interface BookingsHeaderProps {
  selectedTab?: string;
}

export const BookingsHeader = ({ selectedTab }: BookingsHeaderProps) => {
  const isAdmin = useAtomValue(isActiveUserAdminAtom);
  const bookingHeader = useMemo(() => {
    if (isAdmin) {
      return "Team Member Bookings";
    }
    if (selectedTab === BookingTabs.Sessions) {
      return "My Sessions";
    }
    return "My Bookings";
  }, [selectedTab, isAdmin]);
  return <BookingsScreenHeader>{bookingHeader}</BookingsScreenHeader>;
};
